if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
			this.eventContext = this.form.dataset.eventContext;
			this.hideErrors = this.dataset.hideErrors === 'true';
		}

		onSubmitHandler(event) {
			event.preventDefault();
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			this.handleErrorMessage();

			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			this.querySelector('.button-overlay-spinner').classList.remove('hidden');

            if (this.form.classList.contains('is-form-configurator')) {
              const productIdsInput = this.form.querySelector('[name=id]').value;
              const productTitle = this.form.querySelector('[name=id]').getAttribute('data-title')
              const productIdsArray = productIdsInput.split(',').map(id => id.trim());
              let productsToAdd = [];
              
              productIdsArray.forEach((id) => {
                if (id) { 
                  productsToAdd.push({
                    id: parseInt(id),
                    quantity: 1
                  });
                }
              });
              
              const productIdsInputComp = this.form.querySelector('[name=id-comp]').value;  
              const productIdsArrayComp = productIdsInputComp.split(',').map(id => id.trim()); 
              
              productIdsArrayComp.forEach((id) => {
                if (id) { 
                  productsToAdd.push({
                    id: parseInt(id),
                    quantity: 1,
                    properties: {'Parte de': productTitle}
                  });
                }
              });

              const productIdsInputAcce = this.form.querySelector('[name=id-acce]').value;  
              const productIdsArrayAcce = productIdsInputAcce.split(',').map(id => id.trim()); 
              
              productIdsArrayAcce.forEach((id) => {
                if (id) { 
                  productsToAdd.push({
                    id: parseInt(id),
                    quantity: 1,
                    properties: {'Parte de': productTitle}
                  });
                }
              });
              
                            
              let config = {};
              const formData = new FormData(this.form);
   
              formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              
              if (productsToAdd) {
                config = fetchConfig();
                const payload = {
                  items: productsToAdd
                };
                for (const pair of formData.entries()) {
                  if (pair[0] == 'quantity') {
                    payload.items.forEach((item) => {
                      item.quantity = pair[1];
                    });
                  }
      
                  if (pair[0] == 'id' || pair[0] == 'quantity' || pair[0] == 'product-id') continue;
                  payload[pair[0]] = pair[1]
                }
                config.body = JSON.stringify(payload);
              } else {
                config = fetchConfig("javascript");
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                config.body = formData;
              }

              fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});

						this.handleErrorMessage(response.description);
						this.minicart.updateSectionContents();
						return;
					}

					this.minicart.renderContents(response);

					if (window.themeSettings.redirectToCart) {
						location.href = '/cart';
					} else {
						this.minicart.open(submitButton);
					}

					const event = new CustomEvent('cart:item-add', {
						detail: {
							items: [response],
							context: this.eventContext,
						},
					});
					document.dispatchEvent(event);

					publish(PUB_SUB_EVENTS.cartItemAdd, {
						source: this.eventContext,
						items: [response],
					});
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
				});
              
            } else {
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
  
              const formData = new FormData(this.form);
              formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);

              config.body = formData;
          
              fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                      if (response.status) {
                          publish(PUB_SUB_EVENTS.cartError, {
                              source: 'product-form',
                              productVariantId: formData.get('id'),
                              errors: response.errors || response.description,
                              message: response.message,
                          });
    
                          this.handleErrorMessage(response.description);
                          this.minicart.updateSectionContents();
                          return;
                      }
    
                      this.minicart.renderContents(response);
    
                      if (window.themeSettings.redirectToCart) {
                          location.href = '/cart';
                      } else {
                          this.minicart.open(submitButton);
                      }
    
                      const event = new CustomEvent('cart:item-add', {
                          detail: {
                              items: [response],
                              context: this.eventContext,
                          },
                      });
                      document.dispatchEvent(event);
    
                      publish(PUB_SUB_EVENTS.cartItemAdd, {
                          source: this.eventContext,
                          items: [response],
                      });
                  })
                  .catch((e) => {
                      console.error(e);
                  })
                  .finally(() => {
                      submitButton.classList.remove('loading');
                      submitButton.removeAttribute('aria-disabled');
                      this.querySelector('.button-overlay-spinner').classList.add('hidden');
                  });
            }
		}

		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) {
				return;
			}

			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}
	});
}
